<template>
  <el-dropdown class="language_dropdown" trigger="click" @command="handleLanguage">
    <div class="el-dropdown-link language_link" :class="{'language_btn': button}">
      <span>{{languageList[$i18n.locale]}}</span>
      <i class="el-icon-arrow-down el-icon--right"></i>
    </div>
    <el-dropdown-menu slot="dropdown" :placement="placement">
      <el-dropdown-item :command="key" v-for="(lang,key) in languageList" :key="key">
        <span>{{lang}}</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import {
    Languages
  } from '@/locale'
  import {
    mapMutations
  } from 'vuex'
  export default {
    name: 'language',
    props: {
      button: {
        type: Boolean,
        default: false
      },
      placement:{
        type: String,
        default: 'bottom-end',//top/top-start/top-end/bottom/bottom-start/bottom-end
      },
      modal:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        languageList: Languages
      }
    },
    methods: {
      ...mapMutations('user', ['setState']),
      /* 语言下拉框 */
      handleLanguage(val) {
        if(val==this.$i18n.locale){
          return
        }
        if(this.modal){
          this.$confirm(this.$ts('切换语言将刷新页面，确认继续切换?'),this.$ts('提示'),{
            type: 'warning'
          }).then(res=>{
            localStorage.setItem('language', val)
            location.reload()
          }).catch(()=>{})
        }else{
          this.$i18n.locale = val;
          localStorage.setItem('language', val)
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .language {
    &_dropdown {
      height: 30px;
      line-height: 30px;
      margin-left: 20px;
      cursor: pointer;
      user-select: none;
      white-space: nowrap;
      outline: none;
    }

    &_link {
      outline: none !important;
      display: flex;
      align-items: center;
      height: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar/Language.vue